import { createContext } from 'react';

export const AsistenciaMedicaContext  = createContext<any>({});